import { Slot } from '@radix-ui/react-slot'
import clsx from 'clsx'
import React, { useRef } from 'react'

import { useTruncation } from '@/hooks/useTruncation/useTruncation'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from './Tooltip'
import Styles from './Tooltip.module.scss'
interface TruncateWithTooltipProps {
  children: React.ReactNode
  className?: string
  asChild?: boolean
}

export const TruncateWithTooltip: React.FC<TruncateWithTooltipProps> = ({
  children,
  className,
  asChild = false
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const isTruncated = useTruncation(ref)

  const Component = asChild ? Slot : 'div'

  const content = (
    <Component ref={ref} className={clsx(Styles.truncate, className)}>
      {children}
    </Component>
  )

  if (!isTruncated) {
    return content
  }

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent>{children}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
export default TruncateWithTooltip
